module.exports = __webpack_public_path__ + "img/start-page.159a4850.jpg";